import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { debounce } from 'lodash';
import {
  clearBillingList,
  clearFinalInvoice,
  getBillingList,
  getFinalInvoice,
} from 'redux/actions/BillingAction';
import { getServiceCity } from 'redux/actions/UserServiceCity';
import { fetchCompanyList } from 'redux/actions/companyAction';
import BillingFlowTab from './BillingFlowTab';
import BillingFilter from './billingFilter/BillingFilter';
import { billingCompanyCardTabs, billingCreditCardTabs, billingFilterOptions } from 'pages/operation/billing/BillingData';
import './BillingFlow.scss';

const BillingFlow = ({queryParams, payloadData, handleBillingList}) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const [billingFilter, setBillingFilter] = useState({
    parentCompanyName: {},
    subCompanyName: {},
    city: {},
  });
  const [tab, setTab] = useState(queryParams?.status || "all");
  const [page, setPage] = useState(parseInt(queryParams?.page) || 0);
  const [pageSize, setRowsPerPage] = useState(parseInt(queryParams?.pageRowSize) || 10);

  const defaultValues = {
    parentCompany: {
      value: queryParams?.companyId,
      label: queryParams?.companyName,
    },
    cityValue: {
      value: queryParams?.cityId,
      label: queryParams?.cityName,
    },
  };

  useEffect(() => {
    dispatch(getServiceCity());
    dispatch(
      fetchCompanyList({ ...payloadData, pageSize: 10 },
        { searchType: 'globalSearch', loader: 'backDropLoader' }
      )
    );
    return () => {
      dispatch(clearBillingList());
      // TODO backend dependency
      dispatch(clearFinalInvoice())
    };
  }, []);

  useEffect(() => {
    setBillingFilter((prevState) => ({
      ...prevState,
      parentCompanyName: {
        value: queryParams?.companyId,
        label: queryParams?.companyName,
      },
      city: {
        value: queryParams?.cityId,
        label: queryParams?.cityName,
      },
    }));
    setTab(queryParams?.status || 'all');
  }, []);

  const locationOptions = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );

  useEffect(() => {

    if (locationOptions?.length === 1) {
      const singleOption = locationOptions[0];
      setBillingFilter((prevState) => ({
        ...prevState,
        city: { value: singleOption.id, label: singleOption.name },
      }));
      setSearchParams({ ...queryParams, cityId: singleOption.id, cityName: singleOption.name });
      payloadData['city'] = singleOption.id;
      payloadData['cityName'] = singleOption.name;
    }
  }, [locationOptions]);

  const companyTableData = useSelector(
    (state) => state?.userCompany?.companyList?.body
  );

  const billingList = useSelector(
    (state) => state?.getBillingList?.billingList?.data
  );

  const billingListLoader = useSelector(
    (state) => state?.getBillingList?.loading
  );

  const subCompanyOption = companyTableData?.map((val) => {
    return { value: val?.id, label: val.name };
  });

  const cityOption =
    locationOptions?.length &&
    locationOptions?.map((val) => {
      return { value: val?.id, label: val.name };
    });

  const finalInvoiceData = useSelector(
    (state) => state?.getFinalInvoice?.getFinalInvoice?.data
  );

  const finalInvoiceLoader = useSelector(
    (state) => state?.getFinalInvoice?.loading
  );

  // ---Change Tab---
  const handleTab = async(tabValue) => {
    payloadData['page'] = '';
    payloadData['pageSize'] = '';
    payloadData['status'] = tabValue === 'all' ? '' : tabValue;
    setTab(tabValue);
    setPage(0);
    setRowsPerPage(10);
    setSearchParams({...queryParams, status: tabValue === 'all' ? '' : tabValue, page: 0, pageRowSize: 10});
    handleBillingList(payloadData);
  };

  const handleFilter = (name, newValue) => {
    setBillingFilter((prevState) => {
      const updatedFilter = { ...prevState };
  
      if (!newValue?.value) {
        delete updatedFilter[name];
      } else {
        updatedFilter[name] = newValue;
      }
  
      return updatedFilter;
    });
    if (name === 'parentCompanyName') {
      setSearchParams({...queryParams, companyId : newValue?.value || '', companyName: newValue?.label || ''});
       payloadData['companyId'] = newValue?.value || '';
       payloadData['companyName'] = newValue?.label || '';
    }
    else if(name === 'city') {
      setSearchParams({...queryParams, cityId : newValue?.value || '', cityName: newValue?.label || ''});
        payloadData['city'] = newValue?.value || '';
        payloadData['cityName'] = newValue?.label || '';
    }

    if (!newValue?.value) {
      dispatch(clearBillingList());
      if (tab === 'charged') {
        dispatch(clearFinalInvoice());
      }
    }
    handleBillingList(payloadData);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSearchParams({...queryParams, page : newPage});

    if(queryParams?.status === "charged") {
      dispatch(getFinalInvoice({...payloadData,page: newPage }));
    }
    else {
      dispatch(getBillingList({ ...payloadData, page: newPage }));
    }
   
   
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setSearchParams({...queryParams, pageRowSize : event.target.value});
    setPage(0);

    if(queryParams?.status === "charged") {
      dispatch(getFinalInvoice({...payloadData, page: 0, pageSize: parseInt(event.target.value)}));
    }
    else {
      dispatch(
        getBillingList({
          ...payloadData,
          page: 0,
          pageSize: parseInt(event.target.value),
        })
      );
    }
   
  };

  const onHandleAutoSuggestion = debounce((event, value, fieldName) => {
    if (event?.type === 'change') {
      if (value && fieldName === 'parentCompanyName') {
        dispatch(
          fetchCompanyList(
            { search: value },
            { searchType: 'globalSearch', loader: 'backDropLoader' }
          )
        );
      } else {
        dispatch(
          fetchCompanyList(
            { search: '' },
            { searchType: 'globalSearch', loader: 'backDropLoader' }
          )
        );
      }
    }
  }, 500);

  return (
    <div>
      <Grid
        container
        gap={3}
        flexWrap={'nowrap'}
        direction="row"
        alignitem="center"
        className="pt30"
      >
        {billingFilterOptions(
          subCompanyOption,
          subCompanyOption,
          cityOption,
          defaultValues
        ) &&
          billingFilterOptions(
            subCompanyOption,
            subCompanyOption,
            cityOption,
            defaultValues
          )?.map((formData, index) => (
            <Grid
              item
              md={4}
              sm={6}
              xs={12}
              key={index}
              className="commonMultiform"
            >
              <BillingFilter
                billingFilterValue={billingFilter}
                setBillingFilter={setBillingFilter}
                handleFilter={handleFilter}
                formData={formData}
                onHandleAutoSuggestion={onHandleAutoSuggestion}
              />
            </Grid>
          ))}
      </Grid>
      <div className="mt10 billingToCompanyTabs">
        <BillingFlowTab
          billingList={tab === 'charged' ? finalInvoiceData : billingList}
          handleTab={handleTab}
          page={page}
          rowsPerPage={pageSize}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          payloadData={payloadData}
          queryParams={queryParams}
          tab={tab}
          billingListLoader={tab === 'charged' ? finalInvoiceLoader : billingListLoader}
          billingFilter={billingFilter}
          billingTabs = {queryParams?.billingType === "billToCreditCard" ?  billingCreditCardTabs : billingCompanyCardTabs}
        />
      </div>
    </div>
  );
}

export default BillingFlow;
